import React from 'react';

import Layout from '../layout/Layout';

const TermsCookies = () => (
  <Layout
    backLink="home"
    className="c-body--login"
    classNameBodyContainer="c-login__container">
    <div className="c-terms__container">
      <h1>Política de privacidad y Cookies</h1>
      <div>
        <h2>Cookies</h2>
        <p>
          Una cookie es un fichero que se descarga en tu ordenador, tu
          smartphone, tu tablet, etc, al acceder a determinadas páginas web para
          almacenar y recuperar información sobre la navegación que se efectúa
          desde dicho equipo.
        </p>
        <p>
          Las cookies son esenciales para el funcionamiento de internet,
          aportando innumerables ventajas en la prestación de servicios
          interactivos, facilitándole la navegación y usabilidad de nuestra web.
          Tenga en cuenta que las cookies no pueden dañar su equipo y que, a
          cambio, el que estén activadas nos ayudan a identificar y resolver los
          errores.
        </p>
        <p>
          <h3>¿Qué cookies usamos en esta web municipal?</h3>
          <p>
            Cookies de sesión: son cookies temporales que permanecen en el
            archivo de cookies de su navegador hasta que abandonas la página web
            dándole click a Salir, por lo que ninguna queda registrada en el
            disco duro del usuario. La información obtenida por medio de estas
            cookies, sirven para analizar pautas de tráfico en la web. A la
            larga, esto nos permite proporcionar una mejor experiencia para
            mejorar el contenido y facilitando su uso.
          </p>
          <h3>Desactivación de las cookies</h3>
          <p>
            La mayoría de navegadores web permite gestionar, en cualquier
            momento, las preferencias del usuario sobre el uso de las cookies.
            Usted puede cambiar la configuración de cookies en cualquier
            momento, configurando su navegador a través de las opciones que cada
            fabricante facilita para aceptar, o no, las cookies que recibe o
            para que el navegador le avise cuando un servidor quiera guardar una
            cookie:
          </p>
          <p>
            Si rechaza todas las cookies, es posible que no pueda utilizar
            productos o servicios que requieran iniciar sesión ni aprovechar por
            completo todo lo que ofrece.
          </p>
          <p>
            Enlaces o indicaciones de los fabricantes de dispositivos y
            navegadores para la gestión o desactivación de cookies en su
            navegador:
          </p>
          <ul>
            <li>
              Para Internet Explorer:
              <br />
              http://windows.microsoft.com/es-es/windows7/how-to-manage-cookies-in-internet-explorer-9
            </li>
            <br />
            <li>
              Para Chrome:
              <br />
              https://support.google.com/chrome/answer/95647?hl=es
            </li>
            <br />
            <li>
              Para Safari:
              <br /> Edición - Preferencias - Privacidad - Bloquear cookies
              (seleccionar “siempre”).
            </li>
            <br />
            <li>
              Para Mozilla Firefox:
              <br />
              https://support.mozilla.org/es/kb/Borrar%20cookies
            </li>
            <br />
            <li>
              Para Opera:
              <br /> http://help.opera.com/Linux/10.60/es-ES/cookies.html
            </li>
            <br />
            <li>
              Para Android:
              <br /> Menú - Más - Ajustes - Ajustes de privacidad.
            </li>
            <br />
            <li>
              Para Blackberry:
              <br />
              http://docs.blackberry.com/en/smartphone_users/deliverables/32004/Turn_off_cookies_in_the_browser_60_1072866_11.jsp
            </li>
            <br />
            <li>
              Para Safari(IOS):
              <br />
              http://www.windowsphone.com/es-es/how-to/wp7/web/changing-privacy-and-other-browser-settings
            </li>
            <br />
            <li>
              Para Windows Phone:
              <br />
              http://www.windowsphone.com/es-es/how-to/wp7/web/changing-privacy-and-other-browser-settings
            </li>
          </ul>
          Más información Para conocer más información sobre las cookies, te
          invitamos a leer el artículo sobre Cookies de la Wikipedia.
        </p>
      </div>
      <div>
        <h2>Política de privacidad</h2>
        <p>
          La Mancomunitat Els Ports estamos comprometidos con la protección de
          la privacidad y el uso correcto de los datos personales. Es por esto
          que, la presente Política de Privacidad tiene como objeto informar
          acerca del tratamiento de datos de carácter personal que, el de
          Mancomunitat Els Ports, efectúa en este sitio web, sede electrónica y
          en cualquiera de sus subdominios, microsites y/o aplicaciones móviles.
        </p>
        <h3>
          ¿Quién es el Responsable del tratamiento de sus datos personales?
        </h3>
        <p>
          La Mancomunitat Els Ports es quien ostenta la condición de Responsable
          de Tratamiento, estando asesorado y supervisado para la adecuada
          protección por nuestro Delegado de Delegado de Protección de Datos.
        </p>
        <h3>¿Para que tratamos tus datos personales de contacto?</h3>
        <p>
          Los datos que se nos facilitan, así como cualesquiera otros generados
          durante el desarrollo de la relación con la persona
          ciudadana/interesada, los podemos tratar para distintas finalidades en
          función de los servicios municipales que sean objeto de prestación y,
          en todo caso, para mantener el contacto y la comunicación con ésta y
          gestionar la prestación de los servicios demandados /o prestados por
          este . En su caso, finalidades más explícitas y concretas pueden
          indicarse en las cláusulas informativas incorporadas en cada una de
          las vías de toma de datos (formularios web, formularios en papel,
          locuciones o carteles y notas informativas) para supuestos concretos.
        </p>
        <h3>
          ¿Cuál es la base jurídica que legitima el tratamiento de sus datos
          personales? Es decir ¿qué condición fundamenta o habilita el que
          podamos tratar sus datos personales?
        </h3>
        <p>
          La base jurídica que nos legitima para el tratamiento de tus datos
          puede ser diversa: en unos casos puede ser el consentimiento de las
          personas interesadas, en otros el cumplimiento de una obligación legal
          por nuestra parte, en otros el cumplimiento por el de una misión
          realizada en interés público o en ejercicio de Poderes Públicos, en
          otros la protección de intereses vitales y en otros la ejecución de un
          contrato.
        </p>
        <p>
          La aportación de los datos solicitados es obligatoria por ser
          imprescindibles para atender su petición y/o prestar nuestros
          servicios; si no los facilita, no podremos llevarla a cabo o
          prestarlos.
        </p>
        <p>
          Cuando el tratamiento se base en su consentimiento, el mismo se
          entenderá otorgado de forma inequívoca, considerándose dicha
          aportación un acto afirmativo claro por su parte, que manifiesta dicho
          consentimiento.
        </p>
        <h3>¿Por cuánto tiempo conservamos sus datos personales?</h3>
        <p>
          En general, los datos personales que se nos facilitan los
          conservaremos para mantener un historial de atención y gestionar
          nuestros servicios de forma eficiente, siempre y cuando el ciudadano
          no solicite la supresión de sus datos. Incluso solicitada la
          supresión, se mantendrán bloqueados durante el tiempo necesario, y
          limitando su tratamiento, únicamente para alguno de estos supuestos:
          cumplir con las obligaciones legales/contractuales de cualquier tipo a
          que estemos sometidos y/o durante los plazos legales previstos para la
          prescripción de cualesquiera responsabilidades por nuestra parte y/o
          el ejercicio o la defensa de reclamaciones derivadas de la relación
          mantenida con la persona ciudadana/interesada.
        </p>
        <h3>
          ¿Quiénes pueden ser cesionarios o destinatarios de tus datos
          personales?
        </h3>
        <p>
          Los datos que nos proporciona podrán ser comunicados a terceras
          entidades para el cumplimiento de fines directamente relacionados con
          funciones legítimas de persona cedente y persona cesionaria, como a
          las entidades u organismos a los que exista obligación legal de
          realizar comunicaciones de datos, entidades u organizaciones públicas
          o privadas con las que lleguemos a acuerdos para desarrollar
          proyectos, sociales, culturales o deportivos o acuerdos de
          colaboración, etc.
        </p>
        <h3>
          ¿Cuáles son sus derechos en protección de datos y cómo puede
          ejercerlos?
        </h3>
        <p>
          Para ejercitar sus derechos en protección de datos podrá formular una
          solicitud ante cualquiera de los puntos de registro de entrada del ,
          en línea a través de la Sede Electrónica del mismo, así como en la
          dirección de correo electrónico info@mancomunitatelsports.esA estos
          efectos y para más información, puede informarse llamando al teléfono.
        </p>
        <p>
          En todo caso, podrá, igualmente, formular reclamaciones ante la
          Agencia Española de Protección de datos.
        </p>

        <p>
          Mancomunitat Els Ports C/ La Bassa, 12, Vilafranca
          <br />
          Tel: 964 44 03 06 / 964 44 12 66
          <br />
          email: info@mancomunitatelsports.es
        </p>
      </div>
    </div>
  </Layout>
);

export default TermsCookies;
